// Button look, shared by ui/Button and by links that must read as buttons.

const BASE = 'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors '
  + 'focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 '
  + 'dark:focus-visible:ring-offset-gray-900 disabled:cursor-not-allowed disabled:opacity-60';

const VARIANTS = {
  primary: 'bg-blue-600 text-white hover:bg-blue-700 disabled:hover:bg-blue-600',
  secondary: 'border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 '
    + 'dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700',
  danger: 'bg-red-600 text-white hover:bg-red-700 disabled:hover:bg-red-600',
  ghost: 'text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-800',
};

const SIZES = {
  sm: 'min-h-[32px] px-3 py-1.5 text-xs',
  md: 'min-h-[40px] px-4 py-2 text-sm',
  lg: 'min-h-[44px] px-5 py-2.5 text-base',
};

/** Tailwind classes for a button of `variant` and `size`; unknown values fall back to the defaults. */
export const getButtonClassName = ({ variant = 'primary', size = 'md', className = '' } = {}) =>
  [BASE, VARIANTS[variant] || VARIANTS.primary, SIZES[size] || SIZES.md, className].filter(Boolean).join(' ');
